const binding = { modules: {}, dataActions: {} };

    (binding.modules['logrocket'] = {
        c: () => require('partner/modules/logrocket/logrocket.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'logrocket',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/logrocket'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };